var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    {
      directives: [
        {
          name: "resize",
          rawName: "v-resize",
          value: _vm.onResizeHandler,
          expression: "onResizeHandler",
        },
      ],
      staticClass: "pa-1 product-view",
      style: "height: " + (_vm.windowSize.y + 200) + "px; position: 'relative'",
      attrs: { flat: "" },
    },
    [
      _vm.loading
        ? _c(
            "div",
            { staticClass: "text-center" },
            [
              _c("v-progress-circular", {
                attrs: {
                  size: 70,
                  width: 7,
                  color: "primary",
                  indeterminate: "",
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-card-text",
        { staticClass: "pa-0" },
        [
          _c(
            "v-form",
            {
              ref: "receiveForm",
              on: {
                submit: function ($event) {
                  $event.preventDefault()
                },
              },
            },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pb-0 pt-0 font-weight-bold",
                      attrs: { cols: "6" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("message.common.orderno")) +
                          ": " +
                          _vm._s(_vm.orderModel.number)
                      ),
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "pb-0 pt-0 font-weight-bold",
                      attrs: { cols: "6" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("message.layout.warehouse")) +
                          ": " +
                          _vm._s(_vm.orderModel.warehouse_name)
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "pt-0 pr-1 pb-0 mt-1",
                      attrs: { cols: "12" },
                    },
                    [
                      _c("barcode-scanner", {
                        attrs: {
                          search: _vm.scanProduct,
                          scannerPayload: _vm.scannerPayload,
                          loading: _vm.productLoading,
                        },
                        model: {
                          value: _vm.scanProduct,
                          callback: function ($$v) {
                            _vm.scanProduct = $$v
                          },
                          expression: "scanProduct",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm.productFound
                    ? _c(
                        "v-col",
                        {
                          staticClass: "pt-1 pb-1 font-weight-bold",
                          attrs: { cols: "12" },
                        },
                        [
                          !_vm.isNewProduct
                            ? _c("span", [
                                _vm._v(
                                  _vm._s(_vm.productInfo.productname || "")
                                ),
                              ])
                            : _c("span", { staticClass: "red--text" }, [
                                _vm._v(_vm._s(_vm.productInfo.name || "")),
                              ]),
                        ]
                      )
                    : _vm._e(),
                  _vm.productFound
                    ? _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            {
                              staticClass: "py-0 px-1",
                              attrs: {
                                cols:
                                  _vm.productFound && _vm.productInfo.isbatch
                                    ? "6"
                                    : "12",
                              },
                            },
                            [
                              _c("v-autocomplete", {
                                ref: "scanLocation",
                                attrs: {
                                  items: _vm.listOfLocations,
                                  "item-text": "name",
                                  "item-value": "name",
                                  "hide-details": "",
                                  outlined: "",
                                  loading: _vm.loadingLocation,
                                  label: _vm.$t("message.product.scanLoc"),
                                  flat: "",
                                  autocomplete: "off",
                                  dense: "",
                                  rules: _vm.$_requiredValidation,
                                },
                                on: { change: _vm.checkIfLocationValid },
                                model: {
                                  value: _vm.selectedLocation,
                                  callback: function ($$v) {
                                    _vm.selectedLocation = $$v
                                  },
                                  expression: "selectedLocation",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm.productFound && _vm.productInfo.isbatch
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "py-0 px-1",
                                  attrs: { cols: "6" },
                                },
                                [
                                  [
                                    (Math.sign(_vm.pickQty) == 1 ? true : false)
                                      ? _c("v-text-field", {
                                          ref: "batchRef",
                                          attrs: {
                                            outlined: "",
                                            dense: "",
                                            "hide-details": "",
                                            flat: "",
                                            autocomplete: "off",
                                            rules: _vm.$_requiredValidation,
                                            placeholder: _vm.$t(
                                              "message.product.batch"
                                            ),
                                            loading: _vm.loadingBatch,
                                          },
                                          on: {
                                            change: _vm.checkIfBatchContainsQty,
                                          },
                                          model: {
                                            value: _vm.selectBatch,
                                            callback: function ($$v) {
                                              _vm.selectBatch = $$v
                                            },
                                            expression: "selectBatch",
                                          },
                                        })
                                      : _vm._e(),
                                    (Math.sign(_vm.pickQty) == 1 ? false : true)
                                      ? _c("v-autocomplete", {
                                          ref: "batchRef",
                                          attrs: {
                                            items: _vm.listOfBatchNumbers,
                                            "item-text": "batchnumberpwa",
                                            "item-value": "batchnumberpwa",
                                            "hide-details": "",
                                            outlined: "",
                                            loading: _vm.loadingBatch,
                                            label: _vm.$t(
                                              "message.product.batch"
                                            ),
                                            flat: "",
                                            autocomplete: "off",
                                            dense: "",
                                            rules: _vm.$_requiredValidation,
                                          },
                                          on: {
                                            change: _vm.checkIfBatchContainsQty,
                                          },
                                          model: {
                                            value: _vm.selectBatch,
                                            callback: function ($$v) {
                                              _vm.selectBatch = $$v
                                            },
                                            expression: "selectBatch",
                                          },
                                        })
                                      : _vm._e(),
                                  ],
                                ],
                                2
                              )
                            : _vm._e(),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.productFound
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "pa-1 text-right",
                          attrs: { cols: "8" },
                        },
                        [
                          _c(
                            "v-row",
                            [
                              _vm.isNewProduct
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center pa-0",
                                      attrs: { cols: "3" },
                                      on: { click: _vm.decreaseQty },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "info",
                                            fab: "",
                                            "x-small": "",
                                          },
                                        },
                                        [_c("v-icon", [_vm._v("mdi-minus")])],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c(
                                "v-col",
                                {
                                  staticClass: "pa-0 px-1",
                                  class: _vm.isNewProduct ? "" : "",
                                  attrs: { cols: "6" },
                                },
                                [
                                  _c("v-text-field", {
                                    ref: "qtyRef",
                                    staticClass: "text-right",
                                    attrs: {
                                      outlined: "",
                                      dense: "",
                                      "hide-details": "",
                                      type: "number",
                                      disabled: !_vm.isNewProduct,
                                      autocomplete: "off",
                                      rules:
                                        _vm.$_norwegianNumberMinusValidation,
                                      placeholder: _vm.$t(
                                        "message.product.qty"
                                      ),
                                    },
                                    model: {
                                      value: _vm.pickQty,
                                      callback: function ($$v) {
                                        _vm.pickQty = $$v
                                      },
                                      expression: "pickQty",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm.isNewProduct
                                ? _c(
                                    "v-col",
                                    {
                                      staticClass: "text-center pa-0",
                                      attrs: { cols: "3" },
                                      on: { click: _vm.increaseQty },
                                    },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "info",
                                            fab: "",
                                            "x-small": "",
                                          },
                                        },
                                        [_c("v-icon", [_vm._v("mdi-plus")])],
                                        1
                                      ),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { staticClass: "text-center", attrs: { cols: "4" } },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "primary",
                                dark: "",
                                small: "",
                                loading: _vm.saveLoading,
                              },
                              on: { click: _vm.receiveQtyOnOrder },
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("message.order.adjust")) +
                                  " "
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card-text",
        { staticClass: "highlight pt-0 pb-0 pl-1 mt-2" },
        [
          _c(
            "v-row",
            [
              _c(
                "v-col",
                {
                  staticClass: "pa-0 pl-3 font-weight-bold",
                  attrs: { cols: "6" },
                },
                [_vm._v(_vm._s(_vm.$t("message.whsDashboard.product")) + ":")]
              ),
              _c(
                "v-col",
                {
                  staticClass: "pa-0 pr-2 text-center font-weight-bold",
                  attrs: { cols: "3" },
                },
                [_vm._v(_vm._s(_vm.$t("message.ccsheet.unit")))]
              ),
              _c(
                "v-col",
                {
                  staticClass: "pa-0 text-right font-weight-bold",
                  attrs: { cols: "3" },
                },
                [_vm._v(_vm._s(_vm.$t("message.order.ordered")))]
              ),
            ],
            1
          ),
          _c(
            "v-row",
            [
              _c(
                "v-col",
                { staticClass: "pa-0", attrs: { cols: "12" } },
                [_c("v-divider", { staticClass: "pa-0" })],
                1
              ),
            ],
            1
          ),
          _vm._l(_vm.listOfProducts, function (product, index) {
            return _c(
              "v-row",
              {
                key: index,
                staticClass: "pb-3",
                on: {
                  click: function ($event) {
                    return _vm.scanProductByClick(product.productnumber)
                  },
                },
              },
              [
                _c(
                  "v-col",
                  {
                    staticClass: "pa-0 pl-3 text-truncate",
                    class: { "pb-1": index === _vm.listOfProducts.length - 1 },
                    attrs: { cols: "6", title: product.productnumber },
                  },
                  [
                    _vm._v(" " + _vm._s(product.productnumber) + " "),
                    _c("br"),
                    _c("span", [_vm._v(_vm._s(product.productname))]),
                  ]
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "pa-0 text-center text-truncate",
                    attrs: { cols: "3", title: product.unitname },
                  },
                  [_vm._v(_vm._s(product.unitname))]
                ),
                _c(
                  "v-col",
                  {
                    staticClass: "pa-0 text-right text-truncate",
                    attrs: { cols: "3" },
                  },
                  [_vm._v(_vm._s(_vm._f("absoluteNumber")(product.qty)))]
                ),
              ],
              1
            )
          }),
        ],
        2
      ),
      _c(
        "v-btn",
        {
          attrs: {
            small: "",
            color: "primary",
            dark: "",
            absolute: "",
            bottom: "",
            left: "",
            tabindex: "-1",
          },
          on: {
            click: function ($event) {
              return _vm.$router.push("/adjustment_orders/" + _vm.orderId)
            },
          },
        },
        [
          _c("v-icon", { attrs: { left: "" } }, [
            _vm._v("mdi-arrow-left-bold"),
          ]),
          _vm._v(_vm._s(_vm.$t("message.login.back")) + " "),
        ],
        1
      ),
      _c(
        "v-btn",
        {
          attrs: {
            small: "",
            color: "primary",
            dark: "",
            absolute: "",
            bottom: "",
            right: "",
            tabindex: "-1",
          },
          on: {
            click: function ($event) {
              _vm.completeDialog = true
            },
          },
        },
        [_vm._v(" " + _vm._s(_vm.$t("message.order.complete")) + " ")]
      ),
      _c(
        "v-dialog",
        {
          staticClass: "mt-0",
          attrs: { persistent: "" },
          model: {
            value: _vm.completeDialog,
            callback: function ($$v) {
              _vm.completeDialog = $$v
            },
            expression: "completeDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c(
                "v-card-title",
                { staticClass: "pa-2" },
                [
                  _vm._v(" " + _vm._s(_vm.$t("message.ccsheet.info")) + " "),
                  _c("v-spacer"),
                ],
                1
              ),
              _c("v-divider"),
              _c("v-card-text", { staticClass: "pa-2" }, [
                _c("h4", [
                  _vm._v(_vm._s(_vm.$t("message.order.orderComplete"))),
                ]),
              ]),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "info",
                        small: "",
                        loading: _vm.completeLoading,
                      },
                      on: { click: _vm.completeAdjustmentOrder },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.common.yes")))]
                  ),
                  _c(
                    "v-btn",
                    {
                      attrs: { color: "success", small: "" },
                      on: {
                        click: function ($event) {
                          _vm.completeDialog = false
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("message.common.no")))]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }